// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "airplane-4ld8j";
var _4 = "airplane__name-2J-nt";
var _5 = "recommend__wrapper-2IiLq";
var _6 = "passenger__item_recommend-3CsXz";
var _7 = "passenger__avatar-3WIvG";
var _8 = "passenger__item_active-1Nhx1";
var _9 = "passenger__item-2AIIE";
var _a = "recommend-O0QPr";
var _b = "passenger__money-2pbLu";
var _c = "disclaimer__wrp-hh8lP";
var _d = "disclaimer-u_SB6";
var _e = "seatInfo__seat-OQd7X";
var _f = "seatInfo__description-2hLsX";
var _10 = "seatInfo__features-24l5l";
var _11 = "seatInfo__priceWrapper--xAvw";
var _12 = "seatInfo__price-1kt2a";
var _13 = "seat-1KmaV";
var _14 = "seat_recommend-tz0Lr";
var _15 = "seat_recommendCurrent-1uqa3";
var _16 = "seat__number-t1PvS";
var _17 = "title-20yoz";
var _18 = "airplane__seatsDetails-7CO0f";
var _19 = "seatMap__wings-rcTKH";
var _1a = "seatTooltip__tooltip-dL3Pf";
var _1b = "seatTooltip__info-3DaIj";
var _1c = "seatTooltip__tooltip_withInfo-1Qkz0";
var _1d = "airplane__segment-1l_wW";
export { _1 as "__esModule", _2 as "mobile", _3 as "airplane", _4 as "airplane__name", _5 as "recommend__wrapper", _6 as "passenger__item_recommend", _7 as "passenger__avatar", _8 as "passenger__item_active", _9 as "passenger__item", _a as "recommend", _b as "passenger__money", _c as "disclaimer__wrp", _d as "disclaimer", _e as "seatInfo__seat", _f as "seatInfo__description", _10 as "seatInfo__features", _11 as "seatInfo__priceWrapper", _12 as "seatInfo__price", _13 as "seat", _14 as "seat_recommend", _15 as "seat_recommendCurrent", _16 as "seat__number", _17 as "title", _18 as "airplane__seatsDetails", _19 as "seatMap__wings", _1a as "seatTooltip__tooltip", _1b as "seatTooltip__info", _1c as "seatTooltip__tooltip_withInfo", _1d as "airplane__segment" }
export default { "__esModule": _1, "mobile": _2, "airplane": _3, "airplane__name": _4, "recommend__wrapper": _5, "passenger__item_recommend": _6, "passenger__avatar": _7, "passenger__item_active": _8, "passenger__item": _9, "recommend": _a, "passenger__money": _b, "disclaimer__wrp": _c, "disclaimer": _d, "seatInfo__seat": _e, "seatInfo__description": _f, "seatInfo__features": _10, "seatInfo__priceWrapper": _11, "seatInfo__price": _12, "seat": _13, "seat_recommend": _14, "seat_recommendCurrent": _15, "seat__number": _16, "title": _17, "airplane__seatsDetails": _18, "seatMap__wings": _19, "seatTooltip__tooltip": _1a, "seatTooltip__info": _1b, "seatTooltip__tooltip_withInfo": _1c, "airplane__segment": _1d }
